import React from 'react';
import AsyncSelect from 'react-select/async';
import { fetcher } from '../../services/api';
import { CleanDeliveryMethod } from '../../export-types/cleaned-types';

type Props = {
  onChange?: (data: CleanDeliveryMethod[]) => void;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  onFocus?: React.FocusEventHandler<HTMLInputElement>;
  placeholder?: string;
  value: CleanDeliveryMethod[];
  roles?: string[];
};

function getLoader() {
  return async () => fetcher('/delivery-method');
}

export const DeliveryMethodSelect = React.forwardRef(function (
  props: Props,
  ref: React.ForwardedRef<HTMLInputElement>,
) {
  return (
    <AsyncSelect
      placeholder={props.placeholder}
      onBlur={props.onBlur}
      loadOptions={getLoader()}
      cacheOptions
      defaultOptions
      getOptionLabel={(option) => option.name}
      getOptionValue={(option) => option.id}
      isMulti={true}
      onChange={(users) =>
        props.onChange ? props.onChange(users.concat()) : undefined
      }
      onFocus={props.onFocus}
      value={props.value}
      // @ts-ignore
      ref={ref}
    />
  );
});
